import { useState, useRef, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { markContentAsCompleted } from "../../../service/UserCourseService";

export const useContentViewer = ({ selectedRecord, setSelectedRecord, courseId, loadCourseContent, setShowContent,handleNextContent, markSidebarItemAcknowledged, }) => {
    const [viewerType, setViewerType] = useState("");
    const [viewerSrc, setViewerSrc] = useState("");
    const [viewerExtra, setViewerExtra] = useState("");
    const [visible, setVisible] = useState(true);
    const [isContentCompleted, setIsContentCompleted] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    const videoModalRef = useRef(null);
    const pdfModalRef = useRef();

    const userId = jwtDecode(localStorage.getItem("authtoken"))?.userId || localStorage.getItem("userId");

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getResourceType = (link) => {
        if (!link) return "unknown";
        const lower = link.toLowerCase();
        if (lower.includes("youtube.com") || lower.includes("youtu.be")) return "youtube";
        if (lower.endsWith(".mp4") || lower.endsWith(".mov")) return "video";
        if (lower.endsWith(".pdf")) return "pdf";
        if (lower.startsWith("http://") || lower.startsWith("https://")) return "website";
        return "unknown";
    };

    useEffect(() => {
        if (!selectedRecord?.resourceLink) return;
        const resourceType = getResourceType(selectedRecord.resourceLink);
        setViewerExtra(selectedRecord.contentType || "");
        setIsContentCompleted(selectedRecord.acknowledged || false);
        if (resourceType === "youtube" || resourceType === "video") {
            setViewerType("video");
            setViewerSrc(selectedRecord.resourceLink);
        } else if (resourceType === "pdf") {
            setViewerType("pdf");
            setViewerSrc(selectedRecord.resourceLink);
        } else if (resourceType === "website") {
            window.open(selectedRecord.resourceLink, "_blank");
        } else {
            setViewerType(resourceType);
            setViewerSrc(selectedRecord.resourceLink);
        }
    }, [selectedRecord]);

    const handleSidebarChange = async (newContentId) => {
        if (videoModalRef.current) await videoModalRef.current.saveProgress();
        if (pdfModalRef.current) await pdfModalRef.current.saveProgress();
    };

    const closeViewer = () => {
    setViewerType(null);
    setViewerSrc(null);
    setViewerExtra(null);
    };


    const closeContentViewer = () => {
        setShowContent(false);
        setSelectedRecord(null);
        loadCourseContent();
        setViewerType("");
        setViewerSrc("");
        setViewerExtra("");
    };

    const toggleSidebar = () => setVisible((v) => !v);

    const showToastMessage = (type, message, duration = 3000) => {
        setToastType(type);
        setToastMessage(message);
        setShowToast(true);
        setTimeout(() => setShowToast(false), duration);
    };

   const handleMarkAsDone = async () => {
    try {
        const data = await markContentAsCompleted(courseId, selectedRecord.contentId ?? selectedRecord.courseContentId, userId);
        if (data.acknowledged) {
            setIsContentCompleted(true);
            setSelectedRecord((prev) => ({ ...prev, acknowledged: true }));
             markSidebarItemAcknowledged?.(selectedRecord.contentId);
            showToastMessage("success", data.message);
            setTimeout(() => loadCourseContent(), 3000);
            handleNextContent();
        } else {
            showToastMessage("error", data.message || "Failed to mark content as completed");
        }
    } catch (error) {
        showToastMessage("error", error?.response?.data?.message || "An error occurred while marking content as completed");
    }
};

    const renderActionButton = (item) => {
        const resourceType = getResourceType(item.resourceLink);
        if (resourceType === "youtube" || resourceType === "video") {
            return () => { setViewerType("video"); setViewerSrc(item.resourceLink); setViewerExtra(item.contentType); setSelectedRecord(item); };
        }
        if (resourceType === "pdf") {
            return () => { setViewerType("pdf"); setViewerSrc(item.resourceLink); setSelectedRecord(item); };
        }
        if (resourceType === "website") {
            return () => { window.open(item.resourceLink, "_blank"); setSelectedRecord(item); };
        }
        return () => {};
    };

    return {
        viewerType, viewerSrc, viewerExtra,
        visible, isContentCompleted,
        showToast, toastMessage, toastType,
        isMobile, userId,
        videoModalRef, pdfModalRef,
        handleSidebarChange, closeViewer, closeContentViewer,
        toggleSidebar, handleMarkAsDone, renderActionButton,
        setViewerType, setViewerSrc, setViewerExtra,
    };
};